import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { adminLogin } from '../../utils/api'

const AdminLogin = () => {
  const [formData, setFormData] = useState({ email: '', password: '' })
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')

    try {
      const response = await adminLogin(formData)
      if (response.data?.success) {
        localStorage.setItem('admin_token', response.data.data.token)
        navigate('/admin/dashboard')
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please check your credentials.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-dark-bg flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="glass-card w-full max-w-md p-8 md:p-12 relative overflow-hidden rounded-[2.5rem]"
      >
        <div className="absolute -inset-1 bg-gradient-to-r from-orange-500 to-cyan-400 rounded-[2.5rem] blur opacity-10 pointer-events-none"></div>

        <div className="text-center mb-8 flex flex-col items-center relative z-10">
          <div className="relative w-20 h-20 rounded-full p-1 bg-gradient-to-r from-orange-500 via-amber-400 to-cyan-400 shadow-[0_0_25px_rgba(245,158,11,0.4)] mb-4">
            <img
              src="/logo.png"
              alt="MissionMewarSamriddhi Logo"
              className="w-full h-full object-cover rounded-full bg-dark-bg"
            />
          </div>
          <h2 className="text-3xl font-bold font-grotesk text-white">Admin Access</h2>
          <p className="text-gray-400 mt-2 text-sm">Sign in to manage MissionMewarSamriddhi</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6 relative z-10">
          <div>
            <label className="block text-[10px] font-black uppercase tracking-[0.2em] text-gray-500 mb-2">Email Address</label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-2xl text-white placeholder-gray-600 focus:border-orange-500 focus:bg-white/10 focus:outline-none transition-all duration-300"
              placeholder="Enter your Email Address"
              required
            />
          </div>

          <div>
            <label className="block text-[10px] font-black uppercase tracking-[0.2em] text-gray-500 mb-2">Password</label>
            <input
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-2xl text-white placeholder-gray-600 focus:border-orange-500 focus:bg-white/10 focus:outline-none transition-all duration-300"
              placeholder="••••••••"
              required
            />
          </div>

          {error && (
            <div className="p-4 bg-red-500/10 border border-red-500/20 text-red-400 rounded-2xl text-xs font-black uppercase tracking-widest text-center">
              {error}
            </div>
          )}

          <motion.button
            whileHover={{ scale: 1.02, boxShadow: '0 0 30px rgba(245,158,11,0.5)' }}
            whileTap={{ scale: 0.98 }}
            type="submit"
            disabled={loading}
            className="w-full py-4 bg-gradient-to-r from-orange-500 to-amber-500 text-white font-black uppercase tracking-[0.2em] text-xs rounded-2xl transition-all shadow-[0_0_20px_rgba(245,158,11,0.25)] disabled:opacity-50"
          >
            {loading ? 'Authenticating...' : 'Sign In'}
          </motion.button>
        </form>
      </motion.div>
    </div>
  )
}

export default AdminLogin
